import { render, staticRenderFns } from "./CronsDatatable.vue?vue&type=template&id=54d46475"
import script from "./CronsDatatable.vue?vue&type=script&lang=js"
export * from "./CronsDatatable.vue?vue&type=script&lang=js"
import style0 from "./CronsDatatable.vue?vue&type=style&index=0&id=54d46475&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports